import {
    GO_TO_PAYMENTS_ADMINISTRATOR_BEGIN,
    GO_TO_PAYMENTS_ADMINISTRATOR_SUCCESS,
    GO_TO_PAYMENTS_ADMINISTRATOR_FAILURE
} from '../constants'
import { ACTION_STATE } from '../../../common/Utilities'

export function reducer(state, action) {
    switch (action.type) {
        case GO_TO_PAYMENTS_ADMINISTRATOR_BEGIN:
            return {
                ...state,
                goToPaymentsAdministratorState: ACTION_STATE.PENDING
            }
        case GO_TO_PAYMENTS_ADMINISTRATOR_SUCCESS:
            return {
                ...state,
                goToPaymentsAdministratorState: ACTION_STATE.SUCCESS,
                urlPaymentsAdministrator: action.data.urlPaymentsAdministrator
            }
        case GO_TO_PAYMENTS_ADMINISTRATOR_FAILURE:
            return {
                ...state,
                goToPaymentsAdministratorState: ACTION_STATE.ERROR
            }
        default:
            return state
    }
}